/**
 * IUROP Combos Slider
 * Handles slider navigation for combo slides
 */

class IuropCombosSlider {
  constructor(section) {
    this.section = section;
    this.slider = section.querySelector('[data-combo-slider]');
    this.slides = section.querySelectorAll('[data-combo-slide]');
    this.prevButton = section.querySelector('[data-combo-prev]');
    this.nextButton = section.querySelector('[data-combo-next]');

    if (!this.slider || this.slides.length === 0) return;

    this.currentIndex = 0;
    this.totalSlides = this.slides.length;

    this.init();
  }

  init() {
    this.bindEvents();
    this.updateArrowStates();
    this.bindMobileCartButtons();
  }

  bindMobileCartButtons() {
    this.section.querySelectorAll('.iurop-combos__cart-icon-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = btn.dataset.variantId;
        if (!variantId || btn.disabled) return;

        if (typeof window.iuropAddToCart === 'function') {
          window.iuropAddToCart({
            variantId: String(variantId),
            quantity: 1,
            button: btn,
            sourceId: 'iurop-combos',
            openSidecartAfter: false,
            busyText: '...',
            successText: '✓'
          }).catch(function(err) {
            console.error('[IUROP] Error adding to cart:', err);
            btn.disabled = false;
          });
          return;
        }

        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: String(variantId), quantity: 1 })
        })
          .then(function(res) { return res.json(); })
          .then(function() { return fetch('/cart.js').then(function(r) { return r.json(); }); })
          .then(function(cart) {
            btn.disabled = false;
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'iurop-combos',
                data: { source: 'iurop-combos', itemCount: cart.item_count || 0 }
              }
            }));
          })
          .catch(function(err) {
            console.error('[IUROP] Error adding to cart:', err);
            btn.disabled = false;
          });
      });
    });
  }

  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.goToPrev());
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.goToNext());
    }

    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    this.slider.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    this.slider.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe(touchStartX, touchEndX);
    }, { passive: true });
  }

  handleSwipe(startX, endX) {
    const threshold = 50;
    const diff = startX - endX;

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        this.goToNext();
      } else {
        this.goToPrev();
      }
    }
  }

  goToPrev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateSlider();
    }
  }

  goToNext() {
    if (this.currentIndex < this.totalSlides - 1) {
      this.currentIndex++;
      this.updateSlider();
    }
  }

  updateSlider() {
    const translateX = -this.currentIndex * 100;
    this.slider.style.transform = `translateX(${translateX}%)`;
    this.updateArrowStates();
  }

  updateArrowStates() {
    const isAtStart = this.currentIndex === 0;
    const isAtEnd = this.currentIndex === this.totalSlides - 1;

    if (this.prevButton) {
      this.prevButton.classList.toggle('is-active', !isAtStart);
      this.prevButton.disabled = isAtStart;
    }

    if (this.nextButton) {
      this.nextButton.classList.toggle('is-inactive', isAtEnd);
      this.nextButton.disabled = isAtEnd;
    }
  }
}

// Initialize all combo sliders on the page
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.iurop-combos');
  sections.forEach(section => new IuropCombosSlider(section));
});

// Re-initialize on Shopify section load (for theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.iurop-combos');
    if (section) {
      new IuropCombosSlider(section);
    }
  });
}
